import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks';
import { selectSecurity } from '../../store/securitySlice';
import routes from '../../constants/routes';

interface AdminRouteProps {
  children: React.ReactElement;
  fallback?: string;
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children, fallback = routes.root }) => {
  const isAdmin = useAppSelector(selectSecurity).ui.isAdmin;

  if (!isAdmin) {
    return <Navigate to={fallback} replace />;
  }

  return children;
};
